<template>
  <div :class="wrapperClass">
    <table :class="tableClass" border="0">
      <caption v-if="caption">
        {{
          caption
        }}
      </caption>
      <tbody>
        <template v-for="(row, r) in fenceColumns">
          <template v-if="row[0].type == 'title'">
            <tr :key="'row_' + r" class="tg-form-table--second-title">
              <td :colspan="totalCol" align="center">
                {{ row[0].langKey ? $t(row[0].langKey) : row[0].title }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr :key="'row_' + r">
              <template v-for="(column, c) in row">
                <td
                  :key="'col_' + c"
                  class="column"
                  :width="column.children ? columnWidth / 2 : columnWidth"
                  align="center"
                  :rowspan="column.children ? column.children.length : null"
                  :colspan="column.colspan"
                >
                  <slot :name="'header.' + column.name" :column="column">
                    <span>
                      {{
                        column.langKey
                          ? $t("column." + column.langKey, {
                              third_party: $t("column." + column.third_party),
                            })
                          : column.title
                      }}
                    </span>
                  </slot>
                </td>
                <!-- 有群組欄位；宣染第一個欄位 -->
                <template v-if="column.children">
                  <td
                    :key="'col_' + c + '_2'"
                    class="column"
                    :width="columnWidth"
                    align="center"
                  >
                    <div v-if="column.children[0].type != 'empty'">
                      <slot
                        :name="'header.' + column.children[0].name"
                        :column="column.children[0]"
                      >
                        <span>
                          {{
                            column.children[0].langKey
                              ? $t("column." + column.children[0].langKey)
                              : column.children[0].title
                          }}
                          <span
                            class="text-red"
                            v-if="column.children[0].required"
                            >*</span
                          >
                        </span>
                      </slot>
                    </div>
                  </td>
                </template>
                <!-- 宣染action欄位 -->
                <template v-if="showActionCell">
                  <td :key="'col_' + c + '_a'" class="action">
                    <slot
                      :name="
                        'action.' +
                        (column.children
                          ? column.children[0].name
                          : column.name)
                      "
                      :column="column.children ? column.children[0] : column"
                      :row="row"
                    ></slot>
                  </td>
                </template>
                <tg-form-table-cell
                  :key="'col_' + c + '_v'"
                  :column="column.children ? column.children[0] : column"
                  :row="data"
                  :autoFormat="autoFormat"
                ></tg-form-table-cell>
              </template>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
    <template v-if="showFooter">
      <table class="tg-form-table__footer">
        <tfoot>
          <slot name="footer" :columns="columns" :row="data"></slot>
        </tfoot>
      </table>
    </template>
  </div>
</template>

<script>
import TgFormTableCell from "@/components/table/TgFormTableCell";
import _ from "lodash";

export default {
  components: {
    TgFormTableCell,
  },
  provide() {
    return {
      tableRoot: this,
    };
  },
  props: {
    columnWidth: Number,
    cellWidth: Number,
    caption: String,
    columns: Array,
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    autoFormat: {
      type: Boolean,
      default() {
        return true;
      },
    },
    fenceCol: {
      type: Number,
      default() {
        return 1;
      },
    },
    showActionCell: Boolean,
    showFooter: Boolean,
  },
  data() {
    return {
      fenceColumns: [],
      totalCol: 0,
      colspans: {},
    };
  },
  created() {
    this.parseColumns();
  },
  computed: {
    wrapperClass() {
      return ["tg-form-table--wrapper"];
    },
    tableClass() {
      return ["tg-form-table--table"];
    },
  },
  methods: {
    transformColumns(columns, fenceCol) {
      // 先根據title分組
      let col_groups = [];

      // 找到分組的起始index
      let titleIndex = columns.reduce((a, b, i) => {
        if (b.type == "title") {
          a.push(i);
        }
        return a;
      }, []);

      if (titleIndex.length > 0) {
        col_groups.push(columns.slice(0, titleIndex[0]));
        for (let i = 0; i < titleIndex.length; i++) {
          let end = titleIndex[i + 1]
            ? titleIndex[i + 1] - titleIndex[i]
            : undefined;
          col_groups.push([columns[titleIndex[i]]]);

          col_groups.push(columns.slice(titleIndex[i] + 1, end));
        }
      } else {
        col_groups = columns.length > 0 ? [columns] : [];
      }

      let cols = [];

      // 將分組後的欄位集合進行分欄動作
      col_groups.forEach((group) => {
        let col = [];
        let chunks = _.chunk(group, Math.round(group.length / fenceCol));
        let len = chunks[0].length;

        // 第一個欄位跨欄修正
        if (chunks[0][0].type == "cross") {
          let firstCross = chunks[0][0];
          chunks[0] = chunks[0].slice(1);
          col.push(firstCross);
        }

        // 分欄後的集合，根據index順序重新建立欄位集合
        // 使欄位順序顯示為
        // 0   3
        // 1   4
        // 2   5
        for (let i = 0; i < len; i++) {
          let chunk = chunks.reduce((a, b) => {
            let t = b.filter((x, k) => k == i);
            if (t.length > 0) {
              a.push(t[0]);
            }
            return a;
          }, []);
          col = col.concat(chunk);
        }
        cols = cols.concat(col);
      });
      return cols;
    },
    parseColumns() {
      let columns = JSON.parse(JSON.stringify(this.columns));

      let fenceColumns = this.parseFenceColumns(columns, this.fenceCol);

      this.fenceColumns = this.computedColumns(fenceColumns, this.fenceCol);
    },
    parseFenceColumns(columns, fenceCol) {
      columns = this.transformColumns(columns, fenceCol);
      let fenceColumns = [];
      const colNum = fenceCol;

      let colspans = this.colspans;

      // tr index
      let r = 0;
      // td index
      let c = 0;
      let titleIndex = columns.findIndex((x) => x.type == "title");
      let hasMultiTitle = titleIndex > -1;

      for (let index = 0; index < columns.length; index++) {
        let column = columns[index];
        let colIndex = index;

        if (hasMultiTitle) {
          if (colIndex == titleIndex) {
            r = c == 0 ? r : r + 1;
            c = 0;
            // 已經有其他欄位，標題列下移
            if (fenceColumns[r] && fenceColumns[r].length > 0) {
              r = r + 1;
            }
          }
        }

        if (column.type == "cross") {
          // 最近的非cross欄位
          let nextNotCrossIndex = columns.findIndex(
            (x, i) => x.type != "cross" && i > colIndex
          );

          if (hasMultiTitle && nextNotCrossIndex > titleIndex) {
            nextNotCrossIndex = -1;
          }

          // 不在第一個位置
          if (nextNotCrossIndex > -1 && c != 0) {
            let notCrossCol = columns[nextNotCrossIndex];

            // 下一個是 cross
            // 先互換
            if (columns[index + 1] && columns[index + 1].type == "cross") {
              let tmp = columns[index + 1];
              columns[index + 1] = column;
              columns[index] = tmp;
            }

            // 換成notCross
            columns[nextNotCrossIndex] = columns[index];
            columns[index] = notCrossCol;
            column = columns[index];
          }
        }

        // init tr
        if (!fenceColumns[r]) {
          fenceColumns[r] = [];
        }

        if (!colspans[c]) {
          colspans[c] = 0;
        }

        if (column.children) {
          colspans[c] = 2;
          column.children.forEach((sub, i) => {
            // 除了第一個項目與父項目同tr
            // 其他項目為次tr
            if (i !== 0) {
              let ir = r + i;
              sub.parent = column;
              if (!fenceColumns[ir]) {
                fenceColumns[ir] = [];
              }
              fenceColumns[ir][c] = sub;
            }
          });
        } else {
          colspans[c] = Math.max(this.colspans[c], 1);
        }

        fenceColumns[r][c] = column;

        c++;

        // 為整行的欄位
        if (column.type == "cross" || column.type == "title") {
          c = 0;
          r++;
        }

        // 換行
        if (c == colNum) {
          c = 0;
          r++;
        }
      }

      let totalCol = Object.values(colspans).reduce((a, b) => a + b, colNum);

      if (this.showActionCell) {
        totalCol += 2;
      }

      this.totalCol = Math.max(this.totalCol, totalCol);
      this.colspans = colspans;

      return fenceColumns;
    },
    computedColumns(fenceColumns, fenceCol) {
      const colspans = this.colspans;
      // 設定每個欄位的colspan
      return fenceColumns.map((tr) => {
        // 避免群組設定在右側時，左側空洞
        if (!tr[0]) {
          tr[0] = { type: "empty" };
        }

        // 自動補滿表格，避免右側空洞
        if (
          tr[0].type != "cross" &&
          tr[0].type != "title" &&
          tr.length < fenceCol
        ) {
          tr = tr.concat(Array(fenceCol - tr.length).fill({ type: "empty" }));
        }

        tr = tr.map((column, colIndex) => {
          if (colspans[colIndex] && !column.children && !column.parent) {
            column.colspan = colspans[colIndex];
          }

          // 遇到跨欄，將結果欄位設定span
          if (column.type == "cross") {
            column.valuespan = this.totalCol - colspans[0];
          }
          return column;
        });

        return tr;
      });
    },
  },
  watch: {
    columns() {
      this.$nextTick(() => {
        this.parseColumns();
      });
    },
    secondColumns() {
      this.$nextTick(() => {
        this.parseColumns();
      });
    },
  },
};
</script>
